import memoize from 'memoize-one';
import { Platform } from 'react-native';
export const MIN_CLICKABLE_ZONE = 32;
export const getFontSize = memoize(_ref => {
  let {
    sizes,
    dimensions
  } = _ref;
  if (sizes.desktop) {
    return dimensions.desktop;
  }
  if (sizes.tablet) {
    return dimensions.tablet;
  }
  return dimensions.mobile;
});
export const fontWeightFromName = memoize(name => {
  let weight = 400;
  if (name === 'heavy') {
    weight = 900;
  }
  if (name === 'bold') {
    weight = 700;
  }
  if (name === 'medium') {
    weight = 500;
  }
  if (name === 'light') {
    weight = 300;
  }
  return Platform.OS === 'web' ? weight : `${weight}`;
});
export const fontNameFromWeight = memoize(weight => {
  switch (weight) {
    case 900:
      return 'heavy';
    case 700:
      return 'bold';
    case 500:
      return 'medium';
    case 400:
      return 'regular';
    case 300:
    default:
      return 'light';
  }
});